<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('system.text_22')}}</div>
    <div slot="body">
      <a-alert :message="$t('system.global_http_proxy')" type="warning" class="mb-2" />
      <dialog-selected-tips :name="$t('dictionary.globalsetting')" :count="params.data.length" :action="$t('system.text_188', [firstData['label']])" />
      <a-form
        v-bind="formItemLayout"
        :form="form.fc">
        <a-form-item :label="$t('system.text_102')">
          <component :is="element" v-bind="firstData.opt.props" v-decorator="decorators.value" @change="change">
            <template v-if="element === 'a-select'">
              <a-select-option
                v-for="item of firstData.opt.options"
                :key="item.key"
                :value="item.key"
                :disabled="item.disabled">{{ item.label }}</a-select-option>
            </template>
          </component>
        </a-form-item>
        <template v-if="form.fd.value === 'true'">
          <a-form-item :label="$t('system.global_https_proxy.label')" :validateStatus="validateStatus" :help="help">
            <a-input v-decorator="decorators.global_https_proxy" />
            <template v-slot:extra>
              <div>{{ $t('common.example', ['http|https|sock5://proxy.example.com:8080']) }}</div>
              <div>{{ $t('system.global_https_proxy_extra') }}</div>
            </template>
          </a-form-item>
          <a-form-item :label="$t('system.global_http_proxy.label')" :validateStatus="validateStatus" :help="help">
            <a-input v-decorator="decorators.global_http_proxy" />
            <template v-slot:extra>
              <div>{{ $t('common.example', ['http|https|sock5://proxy.example.com:8080']) }}</div>
            </template>
          </a-form-item>
        </template>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'GlobalHttpProxyDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const initialValue = this.params.data[0].value
    let global_http_proxy, global_https_proxy
    if (initialValue === 'true') {
      global_http_proxy = this.params.config.global_http_proxy
      global_https_proxy = this.params.config.global_https_proxy
    }
    return {
      loading: false,
      checked: false,
      form: {
        fc: this.$form.createForm(this),
        fd: {
          value: initialValue,
        },
      },
      decorators: {
        value: [
          'value',
          {
            initialValue,
            rules: [
              {
                required: true,
                message: this.$t('system.text_192'),
                transform: val => R.trim(val),
              },
            ],
          },
        ],
        global_http_proxy: [
          'global_http_proxy',
          {
            initialValue: global_http_proxy,
          },
        ],
        global_https_proxy: [
          'global_https_proxy',
          {
            initialValue: global_https_proxy,
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      help: '',
      validateStatus: 'success',
    }
  },
  computed: {
    firstData () {
      return this.params.data[0]
    },
    element () {
      return this.firstData.opt.component
    },
  },
  methods: {
    doUpdate (data) {
      return this.$http({
        method: 'POST',
        url: `/v1/services/${this.firstData.serviceId}/config`,
        data: {
          action: 'update',
          config: {
            default: data,
          },
        },
      })
    },
    async handleConfirm () {
      try {
        const values = await this.form.fc.validateFields()
        if (values.value === 'false') {
          values.global_https_proxy = ''
          values.global_http_proxy = ''
        }
        if (values.value === 'true') {
          if (!values.global_https_proxy && !values.global_http_proxy) { // 如果开启，https代理与http代理至少需要填写一个
            this.help = this.$t('system.global_http_proxy.error')
            this.validateStatus = 'error'
            return
          } else {
            this.help = ''
            this.validateStatus = 'success'
          }
        }
        const val = values.value
        delete values.value // 删除开关值
        this.loading = true
        const { data } = await this.doUpdate(values)
        const configObj = { config: data.config.default }
        this.params.success(this.firstData.key, this.firstData.opt.formatter ? this.firstData.opt.formatter(val) : val, this.firstData.serviceId, configObj)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    change (v) {
      this.form.fd.value = v
    },
  },
}
</script>
